export const REFRESH_TOKEN = `
  query refreshToken {
    createCustomToken {
      custom_token
      expires_in
    }
  }
`;
